import { Grid2, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addDameNotes,
  deleteDameNote,
  getCompareCandidates,
  getDameNotes,
  getMatchedJdlistResumeData,
  updateDameNote,
} from "../../../api/Api";
import CandidateSupportIco from "../../../assets/icons/CandidateSupportIco";
import ReportBugIco from "../../../assets/icons/ReportBugIco";
import SupportIco from "../../../assets/icons/SupportIco";
import Breadcrumbs from "../../../component/Breadcrumbs";
import SnackBar from "../../../component/SnackBar";
import { LAYOUT } from "../../../redux/Action";
import {
  CompareChatBot,
  CompareChatBotGetCall,
  SupportCall,
  SupportGetCall,
} from "../../../redux/action/ChatBot";
import { FeedBackButton } from "../../../redux/action/Feedback";
import { MinimizeIcon } from "../../../redux/action/Login";
import { DELETE, GET, POST, PUT } from "../../../redux/axios/Axios";
import { buildUrl, HandleSkeletion } from "../../../utils/constants";
import ChatBotLabelText from "../../chat-bot/ChatBotLabelText";
import SideBarChatBot from "../../chat-bot/SIdeBarChatBot";
import { CustomDiv } from "../../chat-bot/style";
import AddUpdateNote from "../../common-components/AddUpdateNote";
import CommonAccordion from "../../common-components/CommonAccordion";
import DeleteNote from "../../common-components/DeleteNote";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import Notes from "../job-information/notes";
import Experience from "../jobs-candidate/components/Experience";
import MatchingSummary from "../jobs-candidate/components/MatchingSummary";
import CompareProfile from "./components/CompareProfile";
import Summary from "../jobs-candidate/components/Summary";
import useMeasure from "react-use-measure";

function JobsCandidateCompare() {
  const navigate = useNavigate();
  const theme = useTheme();
  const param = useParams();
  const firstResumeId = param.firstResumeId;
  const secondResumeId = param.secondResumeId;
  const [pageLoader, setPageLoader] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [listResumeData, setListResumeData] = useState([]);
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const getBreadcrumb = query.get("breadcrumbs");
  const [noteList, setNoteList] = useState([
    { note: "", interaction: "Email", added_by: "username" },
  ]);
  const [bounds] = useMeasure();
  const layout = useSelector((state) => state.layout.layout);
  const dispatch = useDispatch();
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [noteId, setNoteId] = useState("");
  const [notesTableList, setNotesTableList] = useState([]);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const [currentResumeId, setCurrentResumeId] = useState(null);
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const buttonSupport = [
    {
      name: "Job",
      icon: <CandidateSupportIco />,
    },
    {
      name: "Support",
      icon: <SupportIco />,
    },
    {
      name: "Report Bug",
      icon: <ReportBugIco />,
    },
  ];
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [chatBotData, setChatBotData] = React.useState({
    message: [
      { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
    ],
    value: "",
    loader: false,
    pageLoader: false,
    arrow: true,
    geminiBubble: [],
    bubbleCondition: true,
    selectedValue: "Job",
    details: "Hide Details",
    expandDrawer: false,
  });
  const [open, setOpen] = React.useState(true);
  const [isBottomVisible, setIsBottomVisible] = React.useState(true);
  const noteHeaderData = [
    { name: "Title", direction: "asc", sort: false, width: "50%" },
    { name: "Created By", direction: "asc", sort: false, width: "20%" },
    { name: "Date", direction: "asc", sort: false, width: "15%" },
    { width: "15%" },
  ];

  const fetchCandidateCompareList = async () => {
    try {
      const res = await GET(
        getCompareCandidates(firstResumeId, secondResumeId)
      );
      setTableList(res?.data);
    } catch (error) {
      setPageLoader(false);
    }
  };
  const getlistResumeData = async () => {
    try {
      const res = await GET(
        getMatchedJdlistResumeData(firstResumeId, secondResumeId)
      );
      setListResumeData(res?.data || []);
    } catch (error) {
      console.error("Error fetching resume data:", error);
    }
  };

  const handleFetchData = async () => {
    try {
      setPageLoader(true);
      setChatBotData((prev) => ({
        ...prev,
        message: [
          {
            sender: "bot",
            text: "Hi, I am Hailey. How can I assist you today?",
          },
        ],
        value: "",
        loader: false,
        pageLoader: false,
        arrow: true,
        geminiBubble: [],
        bubbleCondition: true,
      }));
      await getlistResumeData();
      await fetchCandidateCompareList();
      await handleChatBotCandidateCall();
      await fetchNotesTableList(firstResumeId, secondResumeId);
      setPageLoader(false);
    } catch (error) {
      setPageLoader(false);
    }
  };
  useEffect(() => {
    handleFetchData();
  }, [firstResumeId, secondResumeId]);

  const handleReplaceSecondaryId = (id) => {
    const currentUrl = window.location.pathname;
    const title = query.get("title");
    const value = query.get("value");
    const idParam = query.get("id");

    const urlParams = new URLSearchParams();

    if (title) urlParams.append("title", title);
    if (value) urlParams.append("value", value);
    if (idParam) urlParams.append("id", idParam);

    if (
      getBreadcrumb &&
      getBreadcrumb !== null &&
      getBreadcrumb !== "null" &&
      getBreadcrumb !== "undefined"
    ) {
      urlParams.append("breadcrumbs", getBreadcrumb);
    }

    const newUrl = `${currentUrl.replace(param.secondResumeId, id)}${
      urlParams.toString() ? `?${urlParams.toString()}` : ""
    }`;

    navigate(newUrl);
  };

  const handleClickAddNote = (resumeId) => {
    setCurrentResumeId(resumeId);
    setOpenNoteDialog(true);
    setNoteId("");
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleCloseNoteDialog = () => {
    setNoteId("");
    setOpenNoteDialog(false);
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleDeleteNote = (row) => {
    setDeleteNoteDialogOpen(true);
    setNoteId(row?.id);
    setNoteList([
      {
        note: row?.note,
        interaction: row?.interaction,
        added_by: row?.added_by,
        created_at: row?.created_at,
      },
    ]);
  };

  const handleDeleteNoteDialogClose = () => {
    setDeleteNoteDialogOpen(false);
    setNoteId("");
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleUpdateNote = (row) => {
    if (row?.id) {
      setNoteId(row?.id);
      setOpenNoteDialog(true);
      setNoteList([
        {
          note: row?.note,
          interaction: row?.interaction,
          added_by: row?.added_by,
        },
      ]);
    }
  };

  const handleCreateNote = async (resumeId) => {
    setAddNoteLoading(true);
    if (resumeId) {
      const payload = noteList;
      if (noteId) {
        const res = await PUT(updateDameNote(noteId), noteList[0]);
        if (res?.success) {
          setSnackbarState({
            open: true,
            severity: "success",
            message: res?.message,
          });
        } else {
        }
      } else {
        const res = await POST(addDameNotes(resumeId), payload);

        if (res?.success) {
          setSnackbarState({
            open: true,
            severity: "success",
            message: res?.message,
          });
        } else {
        }
      }
      setAddNoteLoading(false);
      await fetchNotesTableList(firstResumeId, secondResumeId);
      setOpenNoteDialog(false);
      setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
    }
  };

  const handleDeleteNoteById = async (row) => {
    const res = await DELETE(deleteDameNote(noteId));
    if (res?.success) {
      setSnackbarState({
        open: true,
        severity: "success",
        message: res?.message,
      });
      // setAddNoteLoading(false);
      await fetchNotesTableList(firstResumeId, secondResumeId);
      setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
      setDeleteNoteDialogOpen(false);
      setNoteId("");
    } else {
    }
  };

  const handleNoteTextChange = (index, e) => {
    const newNoteList = [...noteList];
    newNoteList[index].note = e.target.value;
    setNoteList(newNoteList);
  };

  const fetchNotesTableList = async (firstResumeId, secondResumeId) => {
    setNotesTableListLoading(true);
    try {
      const [firstNotes, secondNotes] = await Promise.all([
        GET(getDameNotes(firstResumeId)),
        GET(getDameNotes(secondResumeId)),
      ]);

      setNotesTableList([
        { resumeId: firstResumeId, notes: firstNotes?.data },
        { resumeId: secondResumeId, notes: secondNotes?.data },
      ]);
    } catch (error) {
      console.error("Error fetching notes:", error);
    } finally {
      setNotesTableListLoading(false);
    }
  };

  const breadCrumbData = [
    ...(getBreadcrumb &&
    getBreadcrumb !== "null" &&
    getBreadcrumb !== "undefined"
      ? [
          {
            title: "Work Flow",
            navigate: `/job-krystal-path`,
          },
        ]
      : [
          {
            title: "Jobs",
            navigate: `/jobs`,
          },
        ]),
    {
      title: query.get("title"),

      navigate: buildUrl("/jobs/jobs-view", {}, getBreadcrumb),
    },
    {
      title: "Compare",
      active: true,
    },
  ];

  const handleChatBotCandidateCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
      message: [
        { sender: "bot", text: "Hi, I am Hailey. How can I assist you today?" },
      ],
    }));
    try {
      let param = {
        first_match: firstResumeId,
        second_match: secondResumeId,
      };
      const data = await CompareChatBotGetCall(jobId, param);
      const messages = [];
      data?.data?.history.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        geminiBubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleSendMessage = async () => {
    if (!chatBotData.value.trim()) return;

    let payload;
    if (chatBotData.selectedValue === "Job") {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "match_data",
          job_data_id: query.get("id"),
        },
        match_ids: [firstResumeId, secondResumeId],
      };
    } else {
      payload = {
        query: chatBotData.value,
        filter_criteria: {
          type: "user_manuals",
          user_id: localStorageData?.user_id,
        },
      };
    }

    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, { sender: "user", text: chatBotData.value }],

      loader: true,
      value: "",
    }));

    try {
      let data;
      if (chatBotData.selectedValue === "Job") {
        data = await dispatch(CompareChatBot(payload));
      } else {
        data = await SupportCall(payload);
      }
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleChatBotChange = (event) => {
    setChatBotData((prev) => ({
      ...prev,
      value: event.target.value,
    }));
    if (event.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleUpArrow = (condition) => {
    setChatBotData((prev) => ({
      ...prev,
      arrow: condition === "up" ? false : true,
    }));
  };

  const handleButtonClickByLabel = async (item) => {
    const senderResponse = {
      sender: "user",
      text: item.question,
    };
    setChatBotData((prev) => ({
      ...prev,
      message: [...prev.message, senderResponse],
      loader: true,
    }));
    setChatBotData((prev) => ({
      ...prev,
      arrow: !prev.arrow,
    }));

    let payload = {
      query: item.prompt,
      filter_criteria: {
        type: "match_data",
        job_data_id: query.get("id"),
      },
      match_ids: [firstResumeId, secondResumeId],
    };

    try {
      const data = await dispatch(CompareChatBot(payload));
      const botResponse = {
        sender: "bot",
        text: data?.data?.response,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
      }));
    } catch (error) {
      const botResponse = {
        sender: "error",
        text: error?.data?.message,
      };
      setChatBotData((prev) => ({
        ...prev,
        message: [...prev.message, botResponse],

        loader: false,
        value: "",
      }));
    }
  };

  const handleSupportCall = async () => {
    setChatBotData((prev) => ({
      ...prev,
      pageLoader: true,
    }));
    try {
      const data = await SupportGetCall(localStorageData?.user_id);
      const messages = [];
      data?.history?.forEach((entry) => {
        if (entry.user) {
          const userMessage = {
            sender: "user",
            text: entry.user,
          };
          messages.push(userMessage);
        }
        if (entry.assistant) {
          const botMessage = {
            sender: "bot",
            text: entry.assistant,
          };
          messages.push(botMessage);
        }
      });

      setChatBotData((prev) => ({
        ...prev,
        message: [prev.message[0], ...messages],
        geminiBubble: data?.data?.bubble_questions,
        pageLoader: false,
      }));
      setIsBottomVisible(false);
    } catch (error) {
      setChatBotData((prev) => ({
        ...prev,
        pageLoader: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.message,
      });
    }
  };

  const handleButtonSupport = (name) => {
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: name === "Report Bug" ? prev.selectedValue : name,
    }));
    if (name === "Report Bug") {
      dispatch({ type: LAYOUT.anyChatOpen, data: false });
      dispatch(FeedBackButton(true));
    } else if (name === "Support") {
      handleSupportCall();
    } else if (name === "Job") {
      handleChatBotCandidateCall();
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleToggleDrawer = () => {
    if (!open) {
      handleChatBotCandidateCall();
    }
    setChatBotData((prev) => ({
      ...prev,
      selectedValue: "Job",
      expandDrawer: false,
    }));
    setOpen((prev) => {
      const newState = !prev;
      dispatch(MinimizeIcon(prev, newState));
      return newState;
    });
  };

  const handleActivityChange = () => {
    setChatBotData((prev) => ({
      ...prev,
      details: prev.details === "See Details" ? "Hide Details" : "See Details",
    }));
  };

  useEffect(() => {
    setOpen(!layout.layoutLeft);
  }, [layout]);

  const handleExpandDrawer = () => {
    setChatBotData((prev) => ({
      ...prev,
      expandDrawer: !prev.expandDrawer,
    }));
  };

  return (
    <CustomDiv
      background="#F6F8FB"
      height={"100vh"}
      overflowY="auto"
      display="flex"
    >
      <CommonGrid2
        width={
          open
            ? `calc(100% - ${chatBotData.expandDrawer ? "450px" : "350px"})`
            : "100%"
        }
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
        position={"relative"}
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
      >
        <Breadcrumbs breadCrumbData={breadCrumbData} />

        <Grid2 container spacing={4} marginTop={"1rem"}>
          {pageLoader ? (
            Array.from(new Array(20)).map((el, ind) => (
              <Grid2 item size={4} key={`key-${ind}`}>
                <HandleSkeletion
                  key={`key-${ind.toString()}`}
                  width={"100%"}
                  height={100}
                />
              </Grid2>
            ))
          ) : (
            <>
              {tableList?.candidates?.map((item, index) => (
                <Grid2 size={6}>
                  <CompareProfile
                    index={index}
                    matchedData={item}
                    listResumeData={listResumeData}
                    handleReplaceSecondaryId={(id) =>
                      handleReplaceSecondaryId(id)
                    }
                    checkDropDownData={tableList?.candidates?.map(
                      (item) => item?.record_type
                    )}
                  />
                </Grid2>
              ))}

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Overall"}
                  children={
                    <Grid2 container spacing={3}>
                      {tableList?.candidates?.map((item, index) => (
                        <Grid2 size={6}>
                          <MatchingSummary
                            matchedData={item}
                            handleScoreChange={""}
                          />
                          {/* <Score
                            data={item?.insights?.match_analysis || ""}
                            searchLoading={pageLoader}
                          /> */}
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              {/* <Score
            data={matchedData?.insights?.match_analysis || ""}
            searchLoading={resumeLoader}
          />
          <Grid2 size={12} marginTop={"1rem"}>
            <Summary
              matchedData={matchedData}
              loading={resumeLoader}
              handleQuestionMarkClick={handleQuestionMarkClick}
              iconVisible={iconVisible}
              chatBotData={chatBotData}
              checkWidth={bounds.width}
            />
          </Grid2> */}

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Strengths"}
                  children={
                    <Grid2 container spacing={3}>
                      {tableList?.candidates?.map((item, index) => (
                        <Grid2 size={6}>
                          <Summary
                            matchedData={item}
                            loading={pageLoader}
                            checkWidth={bounds.width}
                          />

                          {/* <StrengthWeak size={12} matchedData={item} /> */}
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Experience"}
                  children={
                    <Grid2 container spacing={3}>
                      {tableList?.candidates?.map((item, index) => (
                        <Grid2 size={6}>
                          <Experience matchedData={item?.experience} />
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Notes"}
                  children={
                    <Grid2 container spacing={3}>
                      {notesTableList.map((item, index) => (
                        <Grid2 key={item.resumeId} size={6}>
                          <Notes
                            handleClickAddNote={() =>
                              handleClickAddNote(item.resumeId)
                            }
                            handleDeleteNoteClick={handleDeleteNote}
                            handleDeleteNoteDialogClose={
                              handleDeleteNoteDialogClose
                            }
                            handleUpdateNoteClick={handleUpdateNote}
                            notesTableList={item.notes}
                            notesTableListLoading={notesTableListLoading}
                            headerData={noteHeaderData}
                          />
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              {/* <Grid2 size={12}>
            <Divider />
          </Grid2> */}

              {/* <Grid2 size={12}>
            <Grid2 container spacing={3}>
              {tableList?.candidates?.map((item, index) => (
                <Grid2 size={6}>
                  <Actions matchedData={item} />
                </Grid2>
              ))}
            </Grid2>
          </Grid2> */}
            </>
          )}
        </Grid2>
      </CommonGrid2>
      <CommonGrid2
        sx={{
          transition: theme.transitions.create(["width"], {
            duration: theme.transitions.duration.short,
            easing: theme.transitions.easing.easeInOut,
          }),
        }}
        width={open ? (chatBotData.expandDrawer ? "450px" : "350px") : "0px"}
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        top={"0px"}
        position={"sticky"}
        right={"0"}
        height={"100%"}
        overflowY={"auto"}
        scrollStyle
        scrollBar="5px"
      >
        {open && (
          <CommonGrid2
            padding={"0rem 1rem 1rem"}
            height={"100%"}
            justifyContent={"space-between"}
            display={"flex"}
            flexDirection={"column"}
          >
            <SideBarChatBot
              handleToggleDrawer={handleToggleDrawer}
              jobId={jobId}
              // height={minimizeScreen}
              chatBotData={chatBotData}
              // handleChatBotFetchData={handleChatBotFetchData}
              handleSendMessage={handleSendMessage}
              handleChatBotChange={handleChatBotChange}
              isBottomVisible={isBottomVisible}
              setIsBottomVisible={setIsBottomVisible}
              handleUpArrow={handleUpArrow}
              handleButtonClickByLabel={handleButtonClickByLabel}
              userName={localStorageData?.username}
              buttonSupport={buttonSupport}
              handleButtonSupport={handleButtonSupport}
              handleActivityChange={handleActivityChange}
              handleExpandDrawer={handleExpandDrawer}
            />
          </CommonGrid2>
        )}
      </CommonGrid2>

      <DeleteNote
        openNoteDialog={openNoteDialog}
        deleteNoteDialogOpen={deleteNoteDialogOpen}
        handleDeleteNoteDialogClose={handleDeleteNoteDialogClose}
        noteList={noteList}
        handleDeleteNoteById={handleDeleteNoteById}
      />
      <AddUpdateNote
        openNoteDialog={openNoteDialog}
        handleCloseNoteDialog={handleCloseNoteDialog}
        id={noteId}
        handleCreateNote={() => handleCreateNote(currentResumeId)}
        noteList={noteList}
        handleNoteTextChange={handleNoteTextChange}
        addNoteLoading={addNoteLoading}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />

      {!open && (
        <ChatBotLabelText
          title={"My name is Hailey. Ask me about this Job"}
          chatBotData={chatBotData}
          handleToggleDrawer={handleToggleDrawer}
        />
      )}
    </CustomDiv>
  );
}

export default JobsCandidateCompare;
